"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useTransition } from "react";
import { Button } from "@repo/ui/mantine";
import { Typography } from "@repo/ui/aops-components/typography";
import { checkoutCartAction } from "@/app/actions/checkout-cart";
import styles from "./CartCheckoutButton.module.css";
type CartCheckoutButtonProps = {
  disabled: boolean;
  errorMessage?: string | null;
};

/**
 * Render a button to checkout the cart
 */
export function CartCheckoutButton(t0) {
  const $ = _c(9);
  const {
    disabled,
    errorMessage
  } = t0;
  const [error, setError] = useState(null);
  const [isPending, startTransition] = useTransition();
  const displayedError = error ?? errorMessage ?? null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleCheckout() {
      startTransition(async () => {
        setError(null);
        const result = await checkoutCartAction();
        if (!result.success) {
          setError(result.errorMessage);
          return;
        }
        window.location.assign(result.checkoutUrl);
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleCheckout = t1;
  const t2 = disabled || isPending;
  let t3;
  if ($[1] !== isPending || $[2] !== t2) {
    t3 = <Button id="cart-checkout" disabled={t2} loading={isPending} onClick={handleCheckout}>Check out</Button>;
    $[1] = isPending;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== displayedError) {
    t4 = displayedError && <Typography variant="bodySmall" className={styles.checkoutError}>{displayedError}</Typography>;
    $[4] = displayedError;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className={styles.checkoutButtonContainer}>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}